import React, { FC, useCallback } from 'react';
import { Box } from '@deckee/deck-hand';
import SignalAppearanceButton from './SignalAppearanceButton';
import { SignalAppearanceTypes } from './SignalAppearance.types';

export interface SignalAppearanceChoicesProps {
  onSelectChoice: (choice: SignalAppearanceTypes) => void;
  activeChoice: SignalAppearanceTypes;
}
const SignalAppearanceChoices: FC<SignalAppearanceChoicesProps> = ({
  activeChoice,
  onSelectChoice,
}) => {
  const handleSelectChoice = useCallback(
    (choice: SignalAppearanceTypes) => {
      onSelectChoice(choice);
    },
    [onSelectChoice],
  );

  return (
    <Box display="flex">
      <SignalAppearanceButton
        onClick={() => handleSelectChoice(SignalAppearanceTypes.Anonymous)}
        active={activeChoice === SignalAppearanceTypes.Anonymous}
        type={SignalAppearanceTypes.Anonymous}
      />
      <SignalAppearanceButton
        onClick={() => handleSelectChoice(SignalAppearanceTypes.Profile)}
        active={activeChoice === SignalAppearanceTypes.Profile}
        type={SignalAppearanceTypes.Profile}
      />
      <SignalAppearanceButton
        onClick={() => handleSelectChoice(SignalAppearanceTypes.Invisible)}
        active={activeChoice === SignalAppearanceTypes.Invisible}
        type={SignalAppearanceTypes.Invisible}
      />
    </Box>
  );
};

export default SignalAppearanceChoices;
